module.exports = __webpack_public_path__ + "static/media/Summerland_Main.f0f89a5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Summerland_Main.jpg
// module id = 179
// module chunks = 0